import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { KeycloakTokenInterceptor } from './authentication/keycloak-token.interceptor';
import { RoleGuard } from './authorization/guards/role.guard';
import { provideState } from '@ngrx/store';
import { UserPrincipalEffects, userPrincipalFeature } from './authorization';
import { provideEffects } from '@ngrx/effects';

@NgModule({
    imports: [CommonModule],
    providers: [
        RoleGuard,
        provideState(userPrincipalFeature),
        provideEffects([UserPrincipalEffects]),
        {
            provide: HTTP_INTERCEPTORS,
            useClass: KeycloakTokenInterceptor,
            multi: true
        }
    ]
})
export class SecurityModule {}
